import { render, staticRenderFns } from "./BlockYoutube.vue?vue&type=template&id=7afa9b6a&"
import script from "./BlockYoutube.vue?vue&type=script&lang=js&"
export * from "./BlockYoutube.vue?vue&type=script&lang=js&"
import style0 from "./BlockYoutube.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports